/* Makeup Geek - visitor offer: extra 10% off for a real 1-hour window per visitor.
 * - The window starts the first time a visitor opens a product page (stored in their browser).
 * - While it is open, the Shopify discount code is applied automatically (cookie + cart), on every page.
 * - When it ends the code is removed again. After COOLDOWN_HOURS a returning visitor gets a new window.
 * Keep CODE identical to the discount code in Shopify admin (Discounts > "Visitor offer: extra 10%").
 */
(function () {
  'use strict';
  var CODE = 'MGHELLO-4K7Q';
  var MINUTES = 60;
  var COOLDOWN_HOURS = 12;
  var KEY = 'mg_offer_v1';
  var DURATION = MINUTES * 60000;
  var COOLDOWN = COOLDOWN_HOURS * 3600000;

  function cookieValue(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function readState() {
    try { var v = localStorage.getItem(KEY); if (v) return JSON.parse(v); } catch (e) {}
    try { var c = cookieValue(KEY); if (c) return JSON.parse(c); } catch (e) {}
    return null;
  }
  function writeState(s) {
    var str = JSON.stringify(s);
    try { localStorage.setItem(KEY, str); } catch (e) {}
    document.cookie = KEY + '=' + encodeURIComponent(str) + '; path=/; max-age=2592000; SameSite=Lax';
  }
  function setDiscountCookie() {
    if (cookieValue('discount_code') === CODE) return;
    fetch('/discount/' + encodeURIComponent(CODE), { redirect: 'manual', credentials: 'same-origin' }).catch(function () {});
  }
  function clearDiscountCookie() {
    if (cookieValue('discount_code') === CODE) document.cookie = 'discount_code=; Max-Age=0; path=/';
  }
  function removeFromCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var apps = cart.cart_level_discount_applications || [];
        var ours = apps.some(function (d) { return d.title === CODE; });
        if (!ours) return;
        var others = apps.filter(function (d) { return d.type === 'discount_code' && d.title !== CODE; })
                         .map(function (d) { return d.title; }).join(',');
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: others })
        });
      })
      .catch(function () {});
  }

  var panel = document.getElementById('mg-offer');   // only exists on in-stock product pages
  var now = Date.now();
  var state = readState();
  if (panel && (!state || typeof state.end !== 'number' || now >= state.end + COOLDOWN)) {
    state = { start: now, end: now + DURATION, cleaned: false };
    writeState(state);
  }
  var active = !!state && typeof state.end === 'number' && now < state.end;

  function endOffer() {
    clearDiscountCookie();
    if (state && !state.cleaned) { state.cleaned = true; writeState(state); removeFromCart(); }
  }

  function initPanel() {
    var el = panel;
    if (!el || !active) return;
    var hh = el.querySelector('[data-hh]');
    var mm = el.querySelector('[data-mm]');
    var ss = el.querySelector('[data-ss]');
    var timer;

    function place() {
      var list = document.querySelector('.hdt-product-info__list');
      if (!list) return false;
      var inv = list.querySelector('.hdt-product__inventory');
      var price = list.querySelector('.hdt-product__price');
      el.classList.add('hdt-product-info__item');
      el.style.order = '0';
      if (inv) { if (el.nextElementSibling !== inv) inv.parentNode.insertBefore(el, inv); }
      else if (price) { if (el.previousElementSibling !== price) price.parentNode.insertBefore(el, price.nextSibling); }
      else return false;
      return true;
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function setText(node, v) { if (node && node.textContent !== v) node.textContent = v; }
    function tick() {
      var left = state.end - Date.now();
      if (left <= 0) { clearInterval(timer); el.hidden = true; endOffer(); return; }
      var s = Math.floor(left / 1000);
      setText(hh, pad(Math.floor(s / 3600)));
      setText(mm, pad(Math.floor((s % 3600) / 60)));
      setText(ss, pad(s % 60));
    }

    if (!place()) return;
    el.hidden = false;
    tick();
    timer = setInterval(tick, 250);

    var list = document.querySelector('.hdt-product-info__list');
    if (list && window.MutationObserver) {
      new MutationObserver(function () {
        if (!el.hidden && (!el.isConnected || el.parentNode !== list)) place();
      }).observe(list, { childList: true });
    }
  }

  if (active) setDiscountCookie(); else if (state) endOffer();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPanel);
  else initPanel();
})();

/* BUY IT NOW: red button under Add to cart. Adds the selected shade + quantity, then goes straight to checkout.
 * (The wallet button is hidden by CSS; Apple Pay / Google Pay are still offered at the top of the checkout.) */
(function () {
  'use strict';
  function init() {
    var atc = document.querySelector('.hdt-product__buy-button .hdt-product-form__submit');
    if (!atc) return;
    var box = atc.parentNode;
    var btn;

    function make() {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mg-buynow';
      btn.textContent = 'Buy it now';
      btn.addEventListener('click', go);
      return btn;
    }
    function unavailable() { return atc.disabled || atc.getAttribute('aria-disabled') === 'true'; }
    function sync() { if (btn) btn.hidden = unavailable(); }
    function go() {
      if (unavailable()) return;
      var f = atc.form;
      var idEl = f && f.elements['id'];
      var qtyEl = f && f.elements['quantity'];
      var id = idEl && idEl.value;
      var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
      if (!id) return;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'One moment...';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function () { btn.disabled = false; btn.textContent = label; });
    }
    function ensure() {
      if (!btn) make();
      if (!btn.isConnected) atc.insertAdjacentElement('afterend', btn);
      sync();
    }

    ensure();
    if (window.MutationObserver) {
      new MutationObserver(ensure).observe(atc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      if (box) new MutationObserver(function () { if (!btn.isConnected) ensure(); }).observe(box, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();